import React, { ReactNode } from 'react';
import { RuntimeError } from './pages/error/RuntimeError';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  // componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
  //     // Optional: log to external service
  //     console.error('Caught by ErrorBoundary:', error, errorInfo);
  // }

  handleRetry = () => {
    // this.setState({ hasError: false, error: null });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <RuntimeError
          onRetry={this.handleRetry}
          error={this.state.error?.message}
          stack={this.state.error?.stack}
        />
      );
    }

    return this.props.children;
  }
}
